import React from "react";
import {
  Box,
  IconButton,
  Typography,
  MenuItem,
  InputLabel,
  Select,
  FormControl,
} from "@mui/material";
import { ArrowBackIosRounded, DownloadRounded } from "@mui/icons-material";
import { Actions } from "../Header";
import { SheetSelection } from "../../AI_Search/AI_Search/components/TabularDialog";
import { usePostHog } from "posthog-js/react";
import { DOWNLOAD_FILE } from "../../../utils/posthogEvents";

function Header({
  file,
  selectedCSV,
  handleChangeCSV,
  handleDeleteFile,
  handleUpdateFile,
  handleGoBack,
}) {
  const { name, csv_file_map } = file;
  const csvList = Object.keys(csv_file_map);
  const posthog = usePostHog();

  const handleDownloadFile = async () => {
    try {
      const response = await fetch(file.file_url);
      if (!response.ok) return;
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = blobUrl;
      a.download = file.name || "file";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(blobUrl);
      posthog.capture(DOWNLOAD_FILE);
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <Box
      px={{ xs: 2, sm: 3 }}
      py={2}
      display={"flex"}
      alignItems={"center"}
      sx={{
        background: "#323639",
        boxShadow:
          "0px 1px 10px 0px rgba(0, 0, 0, 0.12), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 2px 4px 0px rgba(0, 0, 0, 0.20)",
        borderTopLeftRadius: 24,
        borderTopRightRadius: 24,
      }}
      width={"100%"}>
      <Box
        display={"flex"}
        alignItems={"center"}
        width={"calc(100% - 40px)"}
        mr={1}>
        <IconButton onClick={handleGoBack} sx={{ mr: 1, color: "white" }}>
          <ArrowBackIosRounded fontSize="small" />
        </IconButton>
        <Typography variant="h6" noWrap sx={{ color: "white" }}>
          {name}
        </Typography>
      </Box>
      <Box display={"flex"} alignItems={"center"}>
        <SheetSelection
          mode="light"
          csvList={csvList}
          selectedCSV={selectedCSV}
          handleChangeCSV={handleChangeCSV}
        />
        <IconButton onClick={handleDownloadFile}>
          <DownloadRounded sx={{ color: "white" }} />
        </IconButton>
        <Actions
          file={file}
          handleDeleteFile={handleDeleteFile}
          handleUpdateFile={handleUpdateFile}
        />
      </Box>
    </Box>
  );
}

export default Header;
